import React from 'react'
import { useTheme } from '../../../context/theme.context'
import { Spinner } from '../Doc'

function Button({
  onClick,
  type,
  disabled,
  processing,
  className,
  active,
  children,
}: any) {
  const { brandings, getHoverProps } = useTheme()

  // ✅ Fallback gradient colors
  const defaultGradient = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  const defaultHoverGradient =
    'linear-gradient(135deg, #764ba2 0%, #667eea 100%)'

  // ✅ Safe brandings (fallback if undefined)
  const buttonBg = brandings?.buttonBgColor || defaultGradient
  const buttonHover = brandings?.buttonHoverColor || defaultHoverGradient
  const buttonText = brandings?.buttonTextColor || '#FFFFFF'

  {
    console.log(buttonBg, 'buttoncolor')
  }

  return (
    <button
      type={type || 'button'}
      style={{
        color: buttonText,
        background: buttonBg, // ✅ gradient-safe property
        border: 'none',
        transition: 'all 0.3s ease',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = buttonHover)}
      onMouseLeave={(e) => (e.currentTarget.style.background = buttonBg)}
      className={`w-full ${
        active ? 'bg-gray-700' : 'bg-gray-800'
      } focus:outline-none focus:ring-4 font-medium rounded-lg text-sm p-2 me-2 mb-4 hover:bg-gray-700 focus:ring-gray-700 ${className}`}
      onClick={onClick}
      disabled={processing || disabled}
    >
      {processing ? <Spinner /> : children}
    </button>
  )
}

export default Button
